// Dialog global temizat (alert/confirm) — înlocuiește ferestrele native „…says".
// fmAlert/fmConfirm întorc o Promise; DialogHost (montat o dată la rădăcină) le afișează.
import React from "react";
import { t } from './i18n';

let _handler = null;
export function _registerDialog(fn){ _handler = fn; }

export function fmAlert(message, opts={}){
  if(_handler) return _handler({mode:"alert", message, ...opts});
  try{ window.alert(message); }catch(e){}
  return Promise.resolve(true);
}
export function fmConfirm(message, opts={}){
  if(_handler) return _handler({mode:"confirm", message, ...opts});
  return Promise.resolve(window.confirm(message));
}

export function DialogHost(){
  const [state, setState] = React.useState(null);
  React.useEffect(()=>{
    _registerDialog((opts)=> new Promise(resolve=>setState({...opts, resolve})));
    return ()=>_registerDialog(null);
  }, []);
  if(!state) return null;
  const isConfirm = state.mode==="confirm";
  const close = (val)=>{ const r=state.resolve; setState(null); r&&r(val); };
  return (
    <div onClick={()=>close(isConfirm?false:true)}
      style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000,padding:20}}>
      <div onClick={e=>e.stopPropagation()}
        style={{background:"var(--surface)",border:"1px solid var(--border-2)",borderRadius:16,padding:"22px 20px",maxWidth:380,width:"100%",boxShadow:"0 24px 60px -20px rgba(0,0,0,.6)"}}>
        {state.title&&<div style={{fontWeight:700,fontSize:16,marginBottom:8,color:"var(--text)"}}>{typeof state.title==="string"?t(state.title):state.title}</div>}
        <div style={{fontSize:14,lineHeight:1.55,color:"var(--text-2)",whiteSpace:"pre-line"}}>{typeof state.message==="string"?t(state.message):state.message}</div>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:20}}>
          {isConfirm&&<button className="bg" onClick={()=>close(false)}>{t(state.cancelText||"Anulează")}</button>}
          <button className="bp" style={state.danger?{background:"var(--red)"}:undefined} onClick={()=>close(true)}>{t(state.okText||(isConfirm?"Confirmă":"OK"))}</button>
        </div>
      </div>
    </div>
  );
}
